import React, { ReactElement } from 'react';
import { Strip } from '../../Models/Article';
import { TinyMCEContent } from './TinyMCEContent';
import './HtmlContentBlockStrip.scss';

interface HtmlContentBlockStripProps {
    strip: Strip;
}

export function HtmlContentBlockStrip({ strip: { params } }: HtmlContentBlockStripProps): ReactElement {
    // @todo define type
    const { content } = params as { content: string };
    return (
        <div className='HtmlContentBlockStrip'>
            <TinyMCEContent content={content} loadScripts={true} />
        </div>
    );
}
